/**
 * KeywordHighlight (BUILD_SPEC.md §10.4, v1.1.1 2026-05-14).
 *
 * Wraps Arabic flash-keyword phrases inside styled spans with
 * `unicode-bidi: isolate` so highlighting never breaks Arabic line
 * wrapping. Uses detectFlashSpans for exact-token matching: only the
 * bare token "موافقة" (APPROVAL) and the adjacent pair "عدم موافقة"
 * (REJECTION) are highlighted. Affixed forms ("الموافقة", "موافقتهم")
 * stay unstyled. ASSIGNMENT (تكليف) is no longer a flash category in
 * v1.1 and renders as plain text.
 */

import { Fragment } from "react";
import { detectFlashSpans, type FlashSpan } from "../../../../packages/keywords/index.js";

interface Props {
  text: string;
}

const COLOR_CLASS: Record<NonNullable<FlashSpan["kind"]>, string> = {
  APPROVAL: "text-approval dark:text-approval-dark font-semibold",
  REJECTION: "text-rejection dark:text-rejection-dark font-bold",
};

export function KeywordHighlight({ text }: Props) {
  const spans = detectFlashSpans(text);
  return (
    <span className="rtl-isolate">
      {spans.map((span, i) => {
        if (span.kind === null) return <Fragment key={i}>{span.text}</Fragment>;
        return (
          <span key={i} className={`rtl-isolate ${COLOR_CLASS[span.kind]}`}>
            {span.text}
          </span>
        );
      })}
    </span>
  );
}
